import { useGetModuleFirstView } from 'Features/MainWrapper/api/ModuleFirstView/getModuleFirstView'
import { MODULE_NAMES } from 'Features/MainWrapper/api/ModuleFirstView/helper'
import { useSetModuleFirstView } from 'Features/MainWrapper/api/ModuleFirstView/setModuleFirstView'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useEffect } from 'react'

let isFirstCompleteRender = true

const resetFirstLogin = () => (isFirstCompleteRender = true)

export const useIsFirstLogin = () => {
  const { removeSystemMessage } = useAppStore()
  const { data: plansDetails } = useGetPlansDetails()
  const { data: moduleFirstView, isFetched } = useGetModuleFirstView()
  const { mutate: setModuleFirstView } = useSetModuleFirstView()

  useEffect(() => {
    if (isFirstCompleteRender && moduleFirstView && isFetched && !!plansDetails) {
      const isServerFirstEntry = !(MODULE_NAMES.Gateway in moduleFirstView)

      isFirstCompleteRender = false

      if (isServerFirstEntry) {
        setModuleFirstView()
        removeSystemMessage()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plansDetails?.subscriptionId, moduleFirstView, isFetched])

  return {
    isFirstLogin: moduleFirstView && !(MODULE_NAMES.Gateway in moduleFirstView),
    isPaidMarketingUsed: moduleFirstView && MODULE_NAMES.PM in moduleFirstView,
    resetFirstLogin,
  }
}
